export function LockedField({
  label,
  value,
}: {
  label: string
  value?: string | null
}) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-sm leading-none font-medium">{label}</span>
      <p className="py-1 text-sm">{value || '—'}</p>
    </div>
  )
}
